import React from "react";
import { SGPBadgeDark } from "../../contracts";
import { hasSGPBagde } from "../../components";
import { SGPBadge } from "../SGPBadge";
export const ToggleSGPBadge = ({ tags, title, renderSGPNavLink: SGPNavLink }) => {
    if (!hasSGPBagde(tags)) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("span", { className: 'rj-sgp-badge-icon-title', title: title },
        React.createElement(SGPNavLink, null,
            React.createElement(SGPBadge, Object.assign({ className: 'rj-sgp-badge-icon' }, SGPBadgeDark)))));
};
//# sourceMappingURL=ToggleSGPBadge.js.map